import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import { getUserInfoCompanyId, getUserInfo, setVal2Token, getval2Token } from '../../../Login/Auth';
import { Space, SingleLink, EnableBadge, DisableBadge } from '../../Res/BaseButton';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { Pagination } from '../../Res/Pagination';
import { RecruitmentPerformanceContractor } from './RecruitmentPerformanceContractor';
import { api_getRecruitmentPerformanceContractorDepartmentList } from '../../../../api/apiRecruitmentPerformanceContractorRelated';
import { RP_STATUS_COMPANY, ReqRecruitmentPerformanceDepartmentList, KEY_STATUS_COMPANY, KEY_STATUS_DEPARTMENT } from '../../../../item/ItemRecruitmentPerformanceContractorRelated';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_RESERVE, CASE_STATUS_ONBOARD, CASE_STATUS_RESIGN } from '../../../../item/ItemRecruitmentContractor';

export function RecruitmentPerformanceDepartmentList({ id, setIsLoading, OnBoard, isEdit }) {
    const [tokenId, setTokenId] = useState("")

    // const [userInfo] = useState(getUserInfo())
    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")
    const [companyId, setCompanyId] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [departmentId, setDepartmentId] = useState()
    const [departmentName, setDepartmentName] = useState()

    const [caseStatus, setCaseStatus] = useState("1")

    const [recruitmentPerformanceContractorDepartmentList, setRecruitmentPerformanceContractorDepartmentList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [reserveCount, setReserveCount] = useState(0)
    const [onBoardCount, setOnBoardCount] = useState(0)
    const [cancelCount, setCancelCount] = useState(0)
    const [resignCount, setResignCount] = useState(0)

    // useEffect(() => {
    //     //console.log(userInfo)
    //     setCaseOwner(userInfo.accountId)
    //     setCaseOwnerName(userInfo.nickName)
    //     setCompanyId(userInfo.companyId)
    //     setCompanyName(userInfo.companyName)
    //     setDepartmentId(userInfo.departmentId)
    //     setDepartmentName(userInfo.departmentName)
    //     setVal2Token("RecruitmentPerformance", { companyId, companyName, departmentId, departmentName }, id)
    // }, [userInfo])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var obj = getval2Token(KEY_STATUS_COMPANY, id)
            if (obj.companyId === undefined) {
                var userInfo = getUserInfo()
                // setCaseOwner(userInfo.accountId)
                // setCaseOwnerName(userInfo.nickName)
                setCompanyId(userInfo.companyId)
                setCompanyName(userInfo.companyName)
                setDepartmentId(userInfo.departmentId)
                setDepartmentName(userInfo.departmentName)
                setVal2Token(KEY_STATUS_COMPANY, { 
                    accountId: userInfo.accountId, 
                    nickName: userInfo.nickName, 
                    companyId: userInfo.companyId, 
                    companyName: userInfo.companyName, 
                    departmentId: userInfo.departmentId, 
                    departmentName: userInfo.departmentName }, id)
            } else {
                setCaseOwner(obj.accountId)
                setCaseOwnerName(obj.nickName)
                setCompanyId(obj.companyId)
                setCompanyName(obj.companyName)
                setDepartmentId(obj.departmentId)
                setDepartmentName(obj.departmentName)
            }
            setTokenId(id)
        }
    }, [id])

    useEffect(() => {
        if (recruitmentPerformanceContractorDepartmentList.length === 0 && companyId !== "") {
            var mReqRecruitmentPerformanceDepartmentList = new ReqRecruitmentPerformanceDepartmentList({
                companyId,
                start: 0,
                limit,
                caseStatus: RP_STATUS_COMPANY
            })
            toSearch({ item: mReqRecruitmentPerformanceDepartmentList })
        }
    }, [companyId])


    function toSearch({ item, page = 1 }) {
        console.log("toSearch")
        var start = (page - 1) * limit;
        // console.log(item)
        setPage(page)
        var mReqRecruitmentPerformanceDepartmentList = new ReqRecruitmentPerformanceDepartmentList({ companyId, caseOwner, caseStatus, start, limit })
        if (item !== undefined)
            mReqRecruitmentPerformanceDepartmentList.fromJson(item)
        console.log(mReqRecruitmentPerformanceDepartmentList)
        getRecruitmentPerformanceDepartmentList(mReqRecruitmentPerformanceDepartmentList)
    }


    function getRecruitmentPerformanceDepartmentList(mReqRecruitmentPerformanceDepartmentList) {
        console.log(mReqRecruitmentPerformanceDepartmentList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getRecruitmentPerformanceContractorDepartmentList({
            mReqRecruitmentPerformanceDepartmentList,
            success: (obj) => {
                console.log(obj)
                setRecruitmentPerformanceContractorDepartmentList(obj.list)
                setCount(obj.count)
                var reserveCount = 0
                var onBoardCount = 0
                var cancelCount = 0
                var resignCount = 0
                obj.list.map((item) => {
                    reserveCount += item.reserveCount
                    onBoardCount += item.onBoardCount
                    cancelCount += item.cancelCount
                    resignCount += item.resignCount
                })
                setReserveCount(reserveCount)
                setOnBoardCount(onBoardCount)
                setCancelCount(cancelCount)
                setResignCount(resignCount)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    var superTitle = companyName
    var title = '部門績效列表'
    var content =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <EnableBadge count={reserveCount} text={"預定中"} size={3} />
                        <EnableBadge count={onBoardCount} text={"現存"} size={3} />
                        <DisableBadge count={resignCount} text={"剛離職"} size={3} />
                    </div>
                </div>

            </div>
            <Space />
            <RecruitmentPerformanceContractorDepartmentListBox list={recruitmentPerformanceContractorDepartmentList} srl={setRecruitmentPerformanceContractorDepartmentList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <RecruitmentPerformanceContractor id={tokenId} status={RP_STATUS_COMPANY} />
            <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}

function RecruitmentPerformanceContractorDepartmentListBox({ list, srl, count, page, sp }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        // console.log(list)
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentPerformanceContractorDepartmentBox key={list[i].departmentId} item={list[i]} />)
            } else {
                itemList.push(<RecruitmentPerformanceContractorDepartmentBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-2">姓名</th>
                                    {/* <th className="text-center sorting col-sm-1">年齡</th>
                                    <th className="text-center sorting col-sm-1">性別</th> */}
                                    <th className="text-center sorting col-sm-2">預定中</th>
                                    <th className="text-center sorting col-sm-2">現存</th>
                                    <th className="text-center sorting col-sm-2">剛離職</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentPerformanceContractorDepartmentBox({ item }) {
    const [mItem, setItem] = useState({})
    const [companyId, setCompanyId] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [departmentId, setDepartmentId] = useState("")
    const [departmentName, setDepartmentName] = useState("")
    const [reserveCount, setrRserveCount] = useState("")
    const [onBoardCount, setOnBoardCount] = useState("")
    const [resignCount, setrResignCount] = useState("")

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setItem(item)
            setCompanyId(item.companyId)
            setCompanyName(item.companyName)
            setDepartmentId(item.departmentId)
            setDepartmentName(item.departmentName)

            setrRserveCount(item.reserveCount)
            setOnBoardCount(item.onBoardCount)
            setrResignCount(item.resignCount)
        }
    }, [item])

    return (
        <tr role="row">
            <td className="text-center">
                <SingleLink link={"RecruitmentPerformance_SpecialistList"}
                    name={departmentName}
                    Key={KEY_STATUS_DEPARTMENT}
                    val={{ 
                        companyId: companyId,
                        companyName: companyName,
                        departmentId: departmentId,
                        departmentName: departmentName, }} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toSOP()}>{caseContractorName}</a></td> */}
            {/* <td className="text-center"><a href="#A" onClick={e => toIsOrNotOnboardSOP()}>{age}</a></td>
            <td className="text-center">{sex}</td> */}
            <td className="text-center">{reserveCount}</td>
            <td className="text-center">{onBoardCount}&nbsp;</td>
            <td className="text-center">{resignCount}</td>
        </tr>
    )
}
